import { render, staticRenderFns } from "./ViewSplitHorizontal.vue?vue&type=template&id=7b67221c"
import script from "./ViewSplitHorizontal.vue?vue&type=script&lang=js"
export * from "./ViewSplitHorizontal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports